"use client";

import React from "react";
import { ArrowRight, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheFutureIsIntelligent() {
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll();
  return <section id="the-future-is-intelligent" className="dark bg-background text-foreground relative min-h-screen w-full overflow-hidden flex items-center justify-center py-32">
      {/* Animated Background using CSS */}
      <div className="absolute inset-0 z-0 opacity-60 bg-gradient-to-b from-[#0a0f1e] to-[#1a1f2e]">
        {/* Matrix-style streaming lines effect */}
        <div className="absolute inset-0 overflow-hidden">
          {[...Array(20)].map((_, i) => <div key={i} className="absolute w-px bg-gradient-to-b from-transparent via-primary to-transparent animate-stream" style={{
          left: `${i * 5 + Math.random() * 5}%`,
          height: `${100 + Math.random() * 100}px`,
          animationDelay: `${Math.random() * 5}s`,
          animationDuration: `${3 + Math.random() * 4}s`,
          opacity: 0.3 + Math.random() * 0.4
        }} />)}
        </div>
      </div>

      {/* Main Content */}
      <div ref={contentRef} className={`relative z-10 container mx-auto px-4 text-center transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <div className="max-w-5xl mx-auto space-y-8">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/20 text-primary text-sm font-medium mb-6 backdrop-blur-sm">
            <Sparkles className="w-4 h-4" />
            <span>Next-Gen Technology</span>
          </div>

          {/* Hero Heading */}
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold tracking-tight leading-[1.1]">
            <span className="block text-white mb-2">The Future is</span>
            <span className="block bg-gradient-to-r from-[var(--color-primary)] to-[var(--color-chart-2)] bg-clip-text text-transparent pb-4">
              Intelligent
            </span>
          </h1>

          {/* Subheading */}
          <p className="text-xl md:text-2xl text-muted-foreground max-w-2xl mx-auto font-light">
            Nairobi-based AI Excellence. Empowering enterprises with scalable cloud solutions and intelligent automation.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 pt-8">
            <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 text-lg h-14 px-8 rounded-full shadow-[0_0_20px_rgba(6,236,249,0.3)] transition-all hover:scale-105 hover:shadow-[0_0_30px_rgba(6,236,249,0.5)]">
              <Link to="/ConnectPage">
                Get Started
                <ArrowRight className="ml-2 w-5 h-5" />
              </Link>
            </Button>

            <Button asChild variant="ghost" size="lg" className="text-lg h-14 px-8 rounded-full text-white hover:bg-white/10 hover:text-primary transition-all border border-white/10 hover:border-primary/50">
              <Link to="/SolutionsPage">Our Services</Link>
            </Button>
          </div>
        </div>
      </div>

      {/* Bottom Gradient Fade */}
      <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-background to-transparent z-10 pointer-events-none" />

      <style>{`
        @keyframes stream {
          0% {
            transform: translateY(-100%);
            opacity: 0;
          }
          10% {
            opacity: 1;
          }
          90% {
            opacity: 1;
          }
          100% {
            transform: translateY(100vh);
            opacity: 0;
          }
        }
        .animate-stream {
          animation: stream linear infinite;
        }
      `}</style>
    </section>;
}